export default __webpack_public_path__ + "static/media/arrow-right.f928b6d0.svg";